import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "input-text__label tw-inline-block body--auxiliary-01-bold"
}
const _hoisted_2 = ["data-test"]
const _hoisted_3 = { class: "flex align-center gap-2 tw-w-full" }
const _hoisted_4 = ["value", "type", "data-test", "disabled", "placeholder", "maxlength"]
const _hoisted_5 = { class: "flex w-full" }

import InputHelperText from "frontcore/views/select/InputHelperText.vue"
import SVGIcon from 'frontcore/views/icons/SVGIcon.vue'
import TEXT_FIELD_LENGTHS from 'frontcore/constants/textFieldLengths'
import useInputState from 'frontcore/views/input-text/useInputState'
import { reactive, ref, toRefs, watch } from 'vue'

type Emits = {
  (e: 'input', value: string):  void
  (e: 'clear'): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CoreInput',
  props: {
    dataTest: {},
    disabled: { type: Boolean, default: false },
    error: { default: '' },
    iconClass: {},
    iconName: {},
    iconNameLeft: {},
    label: { default: '' },
    maxLength: { default: TEXT_FIELD_LENGTHS.LARGE_TEXT_FIELDS },
    placeholder: { default: '' },
    supportingText: { default: '' },
    type: { default: 'text' },
    value: { default: '' }
  },
  emits: ["input", "clear"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const { dataTest, disabled, error, iconName, value } = toRefs(props)

const initialValue = ref(props.value)

const emit = __emit

const emitValue = (e:Event) => {
  const newValue = (e.target as HTMLInputElement).value
  initialValue.value = newValue
  emit('input', newValue)
}

const clearValue = () => {
  initialValue.value = ''
  emit('input', '')
}

const {
  stateStyleClass,
} = useInputState(reactive({ disabled, error, value }))

watch(
  () => props.value,
  (newValue) => {
    initialValue.value = newValue
  },
  { immediate: true }
)

const isInputFocus = ref(false)
const isMouseEnter = ref(false)

const handleFocus = (isFocus: boolean) => {
  isInputFocus.value = isFocus
}

const handleMouse = (isMouse : boolean) => {
  isMouseEnter.value = isMouse
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-text__container", [_unref(stateStyleClass), {'pointer': !_unref(disabled), 'input-text__state-disabled': _unref(disabled)}]])
  }, [
    (_ctx.label.length >0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "input-text__input-container",
      "data-test": `${_unref(dataTest)}--input-wrapper`,
      onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (handleMouse(true))),
      onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (handleMouse(false)))
    }, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.iconNameLeft)
          ? (_openBlock(), _createBlock(SVGIcon, {
              key: 0,
              class: "input-text__left-icon",
              iconName: _ctx.iconNameLeft
            }, null, 8, ["iconName"]))
          : _createCommentVNode("", true),
        _createElementVNode("input", {
          ref: "input",
          value: initialValue.value,
          type: _ctx.type,
          "data-test": _unref(dataTest),
          disabled: _unref(disabled),
          placeholder: _ctx.placeholder,
          maxlength: _ctx.maxLength,
          class: "input-text__input",
          onInput: emitValue,
          onFocus: _cache[0] || (_cache[0] = ($event: any) => (handleFocus(true))),
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (handleFocus(false)))
        }, null, 40, _hoisted_4),
        (_unref(error))
          ? (_openBlock(), _createBlock(SVGIcon, {
              key: 1,
              colorClass: "fill-auxiliary-error-30",
              iconName: "Error"
            }))
          : _createCommentVNode("", true),
        (_unref(error) || isInputFocus.value || isMouseEnter.value)
          ? (_openBlock(), _createBlock(SVGIcon, {
              key: 2,
              colorClass: "fill-core-neutral-cold-20",
              iconName: "Close",
              remSize: 1,
              onClick: clearValue
            }))
          : _createCommentVNode("", true),
        (_unref(iconName))
          ? (_openBlock(), _createBlock(SVGIcon, {
              key: 3,
              colorClass: _ctx.iconClass,
              iconName: _unref(iconName)
            }, null, 8, ["colorClass", "iconName"]))
          : _createCommentVNode("", true)
      ])
    ], 40, _hoisted_2),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "supporting-text", {}, () => [
        _createVNode(InputHelperText, {
          "data-test": `${_unref(dataTest)}--supporting-text`,
          error: _unref(error),
          supportingText: _ctx.supportingText
        }, null, 8, ["data-test", "error", "supportingText"])
      ]),
      _renderSlot(_ctx.$slots, "supporting-text-right-content")
    ])
  ], 2))
}
}

})